import { H4 } from "@blueprintjs/core"
import styled from "@emotion/styled"
import { FlexContainer } from "../../../../styled/flexbox.styled"

export const FormContainer = styled(FlexContainer)({
  padding: "10px 0",
})

export const SectionTitle = styled(H4)({
  margin: 0,
})

export const FieldsContainer = styled(FlexContainer)({
  "& .bp5-form-group": {
    margin: 0,
    display: "flex",
    alignItems: "center",
  },
  "& .bp5-form-group.bp5-inline": {
    flexDirection: "row",
  },
  "& .bp5-label": {
    minWidth: "150px",
    flexShrink: 0,
  },
  "& .bp5-form-content": {
    flex: 1,
  },
})
